import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router';
import Clients from './pages/Clients';
import Visits from './pages/Visits';
import Clinic from './pages/Clinic';
import ClientForm from './pages/ClientForm';
import React, { useContext } from "react";
import DashboardLayout from "./layout/DashboardLayout";
import PetForm from "./pages/PetForm";
import VisitForm from "./pages/VisitForm";
import Test from "./pages/Test";
import Login from "./pages/account/Login";
import ForgotPassword from "./pages/account/ForgotPassword";
import ResetPassword from "./pages/account/ResetPassword";
import Manage from './pages/account/Manage';
import Email from './pages/account/manage/Email';
import ChangePassword from './pages/account/manage/ChangePassword';
import ExternalLogins from './pages/account/manage/ExternalLogins';
import TwoFactorAuthentication from './pages/account/manage/TwoFactorAuthentication';
import PersonalData from './pages/account/manage/PersonalData';
import Profile from './pages/account/manage/Profile';
import { UserContext } from './contexts/UserContext';
import { Box, CircularProgress } from '@mui/material';

function RequireAuth({ children }) {
    const { user, loading } = useContext(UserContext);

    if (loading) {
        return (
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh' 
            }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        return <Login />;
    }

    return children;
}

export function VetRouter() {
    return (
        <Router basename="/app">
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/account/forgotpassword" element={<ForgotPassword />} />
                <Route path="/account/resetpassword" element={<ResetPassword />} />
                <Route element={
                    <RequireAuth>
                        <DashboardLayout />
                    </RequireAuth>
                }>
                    <Route path="/" element={<Navigate to="/visits" replace />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/visits" element={<Visits />} />
                    <Route path="/visits/:id" element={<VisitForm />} />
                    <Route path="/clinic" element={<Clinic />} />
                    <Route path="/clients/:id" element={<ClientForm />} />
                    <Route path="/pets/:id" element={<PetForm />} />
                    <Route path="/test" element={<Test />} />
                    <Route path="/account/manage" element={<Manage />}>
                        <Route index element={<Profile />} />
                        <Route path="email" element={<Email />} />
                        <Route path="change-password" element={<ChangePassword />} />
                        <Route path="external-logins" element={<ExternalLogins />} />
                        <Route path="two-factor-authentication" element={<TwoFactorAuthentication />} />
                        <Route path="personal-data" element={<PersonalData />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    );
}

